import About from "./About";

import Footer from "./Footer";
export default function HeaderAbout() {
    return (
      <div>
        
        <About/>
        <Footer/>
      </div>
    );
  }
  